import DropdownNav from "./DropdownNav";

function Header() {
    return(
        <div>
            {/* large screens */}
            <div className='hidden-xs' id="menu-bar">
                <div id="menu-items">
                    <a style={{textDecoration:'none'}} href="/"><span id="menu-item">Home</span></a>
                    <a style={{textDecoration:'none'}} href="/about"><span id="menu-item">About</span></a>
                    <a style={{textDecoration:'none'}} href="/services"><span id="menu-item">Services</span></a>
                    <a style={{textDecoration:'none'}} href="/contact"><span id="menu-item">Contact</span></a>
                </div>
            </div>

            {/* smallest screens */}
            <div style={{height:'75px'}} className='visible-xs' id="menu-bar">
                <DropdownNav style={{float:'right'}}/>
                <br/>
            </div>
        </div>
    )
}
export default Header;